window.image_lazyload = (imageSelector, cb = null) => {
    let lazyloadImages;
    // check if IntersectionObserver is supported
    if ("IntersectionObserver" in window) {
        // console.log("Observer in window")
        // we work with elements having class: selected-photo-as-bg & lazy
        lazyloadImages = document.querySelectorAll(imageSelector);
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                // if (entry.isIntersecting) {
                // console.log(entry)
                if (entry.intersectionRatio > 0) {
                    let image = entry.target;
                    image.classList.add("loaded");
                    image.src = image.dataset.src;
                    image.removeAttribute("data-src");
                    if (image.dataset.srcset) {
                        image.srcset = image.dataset.srcset;
                        image.removeAttribute("data-srcset");
                    }
                    imageObserver.unobserve(image);
                    if (cb) {
                        cb(image);
                    }
                }
            });
        };

        let imageObserver = new IntersectionObserver(callback);
        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
        });
    } else {
        // console.log("Observer NOT IN window")
        let lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(imageSelector);
        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }
            lazyloadThrottleTimeout = setTimeout(function () {
                let scrollTop = window.pageYOffset;
                lazyloadImages.forEach(function (image) {
                    if (image.offsetTop < window.innerHeight + scrollTop) {
                        image.src = image.dataset.src;
                        image.removeAttribute("data-src");
                        if (image.dataset.srcset) {
                            image.srcset = image.dataset.srcset;
                            image.removeAttribute("data-srcset");
                        }
                        image.classList.add("loaded");
                        if (cb) {
                            cb(image);
                        }
                    }
                });
                if (lazyloadImages.length === 0) {
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }
        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    }
};


// Lazy Section
window.section_scroll = (blockSelector, cb = null) => {
    let lazyloadBlocks;
    // check if IntersectionObserver is supported
    if ("IntersectionObserver" in window) {
        // console.log("Observer in window")
        // we work with elements having class: selected-photo-as-bg & lazy
        lazyloadBlocks = document.querySelectorAll(blockSelector);
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                // if (entry.isIntersecting) {
                // console.log(entry)
                if (entry.intersectionRatio > 0) {
                    let block = entry.target;
                    block.classList.add("loaded");
                    imageObserver.unobserve(block);
                    if (cb) {
                        cb(block);
                    }
                }
            });
        };

        let imageObserver = new IntersectionObserver(callback);
        lazyloadBlocks.forEach(function (block) {
            imageObserver.observe(block);
        });
    } else {
        // console.log("Observer NOT IN window")
        let lazyloadThrottleTimeout;
        lazyloadBlocks = document.querySelectorAll(blockSelector);
        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }
            lazyloadThrottleTimeout = setTimeout(function () {
                let scrollTop = window.pageYOffset;
                lazyloadBlocks.forEach(function (block) {
                    if (block.offsetTop < window.innerHeight + scrollTop) {
                        block.classList.add("loaded");
                        if (cb) {
                            cb(block);
                        }
                    }
                });
                if (lazyloadBlocks.length === 0) {
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }
        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    }
};